// state
import * as types from '~/store/mutation-types'
import axios from 'axios'
import companyService from '../services/company'

export const state = {
  company: {
    addresses: [],
    buyers: [],
    responseMessage: '',
    buyer: '',
    companies: [],
    rep: ''
  },
  // Admin management state
  adminCompanies: [],
  adminCompaniesTotal: 0,
  adminCompaniesCurrentPage: 1,
  adminCompaniesTotalPages: 0,
  adminReps: [],
  adminLoading: false
}

// getters
export const getters = {
  company: (state) => state.company,
  companyInfo: (state) => state?.company?.company_info,
  companyId: (state) => state?.company?.id,
  companyBuyers: (state) => state?.company?.buyers,
  companyAddresses: (state) => state?.company?.addresses,
  getBillAddressData: (state) => billId => {
    return state.company.addresses.filter(el => el.billing_address_id === billId)
  },
  getShipAddressData: (state) => shipId => {
    return state.company.addresses.filter(el => el.shipping_address_id === shipId)
  },
  responseMessage: state => state.responseMessage,
  buyer: state => state.buyer,
  companies: (state) => state.companies,
  rep: (state) => state?.company?.rep,
  // Admin getters
  adminCompanies: (state) => state.adminCompanies,
  adminCompaniesTotal: (state) => state.adminCompaniesTotal,
  adminCompaniesCurrentPage: (state) => state.adminCompaniesCurrentPage,
  adminCompaniesTotalPages: (state) => state.adminCompaniesTotalPages,
  adminReps: (state) => state.adminReps,
  adminLoading: (state) => state.adminLoading
}

// mutation
export const mutations = {
  [types.SET_COMPANIES] (state, companies) {
    state.companies = companies
  },
  [types.SET_COMPANY] (state, { company }) {
    state.company = company
  },
  [types.UPDATE_COMPANY_INFO] (state, payload) {
    state.company.company_info = {
      ...state.company.company_info,
      ...payload
    }
  },
  [types.ADD_COMPANY_BUYER] (state, {data}) {
    state.buyer = data
    const buyer = state.company.buyers.find(buyer => buyer.buyer_id === data.buyer_id)
    if (!buyer) {
        state.company.buyers.push(data)
    }
  },
  'ADD_COMPANY_ADDRESS' (state, payload) {
    state.company.addresses.push({ ...payload, address_id: payload.id })
  },
  'UPDATE_COMPANY_BUYER' (state, {data, message}) {
    state.responseMessage = message
    state.buyer = data
    state.company.buyers = state.company.buyers.map(buyer => {
      if (buyer.buyer_id === data.buyer_id) {
        return { ...buyer, ...data }
      }
      return buyer
    })
  },
  'UPDATE_COMPANY_ADDRESS' (state, payload) {
    state.company.addresses = state.company.addresses.map(address => {
      if (address.address_id === payload.address_id) {
        const data = { ...address, ...payload }
        return data
      }
      return address
    })
  },
  'SET_UPDATE_COMPANY_RESPONSE' (state, {message}) {
    state.responseMessage = message
  },
  // Admin mutations
  'SET_ADMIN_COMPANIES' (state, data) {
    // Handle new PaginatedResourceCollection structure: { data: { data: [...], current_page, total, total_pages, per_page } }
    state.adminCompanies = data.data.data
    state.adminCompaniesTotal = data.data.total
    state.adminCompaniesCurrentPage = data.data.current_page
    state.adminCompaniesTotalPages = data.data.total_pages
  },
  'SET_ADMIN_REPS' (state, reps) {
    state.adminReps = reps
  },
  'SET_ADMIN_LOADING' (state, loading) {
    state.adminLoading = loading
  }
}
// actions
export const actions = {
   async fetchCompanies ({ commit }, params = {}) {
        try {
            const { data: data } = await companyService.fetchCompanies(params)

            commit(types.SET_COMPANIES, data.data)
            return data.data
        } catch (error) {
            if (!axios.isCancel(error)) console.error(error)
            return []
        }
  },
  async getCompany ({ commit }, {companyId, withDropShipAddress = false }) {
    try {
      const { data: { data } } = await companyService.getCompany(companyId, withDropShipAddress)
      commit(types.SET_COMPANY, { company: data })
    } catch (error) {
      console.error(error)
    }
  },
  async getCompanyById ({ commit }, companyId) {
    return await companyService.getCompany(companyId)
  },

  async updateCompanyInfo ({ commit }, { companyId, payload }) {
    try {
      const { data: { message } } = await companyService.updateCompanyInfo(companyId, payload)
      commit(types.UPDATE_COMPANY_INFO, payload)

        const { data: { data } } = await companyService.getCompany(companyId, false)
        commit(types.SET_COMPANY, { company: data })

      return message
    } catch (error) {
      throw error
    }
  },
  async addCompanyBuyer ({ commit, dispatch }, { payload }) {
    const { data: { data, message } } = await companyService.addCompanyBuyer(payload)
    commit(types.ADD_COMPANY_BUYER, {data})
    await dispatch('auth/fetchUser', null, { root: true })
    return { data, message }
  },
  async updateCompanyBuyer ({ commit, dispatch }, { buyerId, payload }) {
      const { data: { data, message } } = await companyService.updateCompanyBuyer(buyerId, payload)
      commit('UPDATE_COMPANY_BUYER', {data, message})
      await dispatch('auth/fetchUser', null, { root: true })
      return { data, message }
  },
  async addCompanyAddress ({ commit, dispatch }, { payload, extra }) {
    try {
      const { data: { data, message } } = await companyService.addCompanyAddress(payload)
      commit('ADD_COMPANY_ADDRESS', { ...data, ...extra })
      await dispatch('auth/fetchUser', null, { root: true })
      return { data, message }
    } catch (error) {
        const data = error.response.data
        const message = error.response.data.message
        const status = error.response.status
        return {data, message, status}
    }
  },
  async updateCompanyAddress ({ commit, dispatch }, payload) {
    try {
      const { data } = await companyService.updateCompanyAddress(payload.address_id, payload)
      const message = data.message ? data.message : 'Address updated successfully';
      commit('UPDATE_COMPANY_ADDRESS', { ...payload })
      await dispatch('auth/fetchUser', null, { root: true })
      return { data: { ...payload, id: payload.address_id }, message: message }
    } catch (error) {
      console.log('Error: ', error)
    }
  },
  async deleteCompanyBuyer({ commit, dispatch }, { buyerId, payload }) {
    try {
      const { data: { data, message } } = await companyService.deleteCompanyBuyer(buyerId, payload)
      await dispatch('auth/fetchUser', null, { root: true })
      return message
    } catch (error) {
        const message = error.response.data.message
        const status = error.response.status
        return { message, status }
    }
  },
  async deleteCompany({ commit, dispatch }, companyId) {
      try {
          const { data: { deleted } } = await companyService.deleteCompany(companyId)
          return deleted
      } catch (error) {
          console.error('Error deleting company:', error)
      }
  },
  async uploadCompanyLogo ({ commit, dispatch }, { companyId, file }) {
    try {
        const formData = new FormData()
        formData.append('logo', file)

        const { data: { data, message } } = await companyService.uploadLogo(companyId, formData)
        return { data, message, status: 200 }
    } catch (error) {
        const data = error.response.data
        const message = error.response.data.message
        const status = error.response.status
        return { data, message, status }
    }
  },
  async fetchCompanyLogos ({ commit }, companyId) {
    try {
        const { data: { data, message } } = await companyService.getCompanyLogos(companyId)
        return { data, message, status: 200 }
    } catch (error) {
        if (error.response) {
            const data = error.response.data
            const message = error.response.data.message
            const status = error.response.status
            return { data, message, status }
        }
    }
  },
  async activateCompanyLogo ({ commit }, logoId) {
    try {
        const { data: { message } } = await companyService.activateCompanyLogo(logoId)
        return { message, status: 200 }
    } catch (error) {
        if (error.response) {
            const data = error.response.data
            const message = error.response.data.message
            const status = error.response.status
            return { data, message, status }
        }
    }
  },
  async deleteCompanyLogo ({ commit }, { companyId, logoId }) {
    try {
        const { data: { message } } = await companyService.deleteCompanyLogo(companyId, logoId)
        return { message, status: 200 }
    } catch (error) {
        const data = error.response.data
        const message = error.response.data.message
        const status = error.response.status
        return { data, message, status }
    }
  },
  async enableDigitalCatalog ({ commit }, companyId) {
    try {
        const { data: { message } } = await companyService.enableDigitalCatalog(companyId)
        return { message, status: 200 }
    } catch (error) {
        const data = error.response.data
        const message = error.response.data.message
        const status = error.response.status
        return { data, message, status }
    }
  },
  // Admin company management actions
  async fetchAdminCompanies ({ commit }, params = {}) {
    commit('SET_ADMIN_LOADING', true)
    try {
      const { data } = await companyService.fetchAdminCompanies(params)
      commit('SET_ADMIN_COMPANIES', data)
      // Return the nested data structure for the component
      return data.data
    } catch (error) {
      console.error('Error fetching admin companies:', error)
      throw error
    } finally {
      commit('SET_ADMIN_LOADING', false)
    }
  },
  async importCompanies ({ commit }, formData) {
    try {
      const { data } = await companyService.importCompanies(formData)
      return data
    } catch (error) {
      console.error('Error importing companies:', error)
      throw error
    }
  },
  async exportCompanies ({ commit }, exportData) {
    try {
      const { data } = await companyService.exportCompanies(exportData)
      return data
    } catch (error) {
      console.error('Error exporting companies:', error)
      throw error
    }
  },
  async bulkDeleteCompanies ({ commit }, ids) {
    try {
      const { data } = await companyService.bulkDeleteCompanies(ids)
      return data
    } catch (error) {
      console.error('Error bulk deleting companies:', error)
      // If it's a validation error (422) or other expected error, return the response data
      if (error.response && error.response.data) {
        return error.response.data
      }
      throw error
    }
  },
  async fetchReps ({ commit }) {
    try {
      const { data } = await companyService.fetchReps()
      // API returns { results: [...] }
      const reps = data.results || []
      commit('SET_ADMIN_REPS', reps)
      return reps
    } catch (error) {
      console.error('Error fetching reps:', error)
      throw error
    }
  },
  
  // Column management actions
  async fetchCompanyColumns ({ commit }) {
    try {
      const { data } = await companyService.getCompanyColumns()
      return data
    } catch (error) {
      console.error('Error fetching company columns:', error)
      throw error
    }
  },
  
  async updateCompanyColumn ({ commit }, columnName) {
    try {
      const { data } = await companyService.updateCompanyColumn(columnName)
      return data
    } catch (error) {
      console.error('Error updating company column:', error)
      throw error
    }
  },
  
  async updateCompanyColumnOrder ({ commit }, orderedColumns) {
    try {
      const { data } = await companyService.updateCompanyColumnOrder(orderedColumns)
      return data
    } catch (error) {
      console.error('Error updating company column order:', error)
      throw error
    }
  },

  async createCompany ({ commit }, companyData) {
    try {
      const { data } = await companyService.createCompany(companyData)
      return data
    } catch (error) {
      console.error('Error creating company:', error)
      throw error
    }
  },

  async downloadCompanyTemplate ({ commit }) {
    try {
      const response = await companyService.downloadCompanyTemplate()
      return response.data
    } catch (error) {
      console.error('Error downloading company template:', error)
      throw error
    }
  }
}
